export const SET_WORKOUT = 'setWorkout';
export const CLEAR_WORKOUT = 'clearWorkout';
export const SET_PROGRAM = 'setProgram';
export const CLEAR_PROGRAM = 'clearProgram';
export const SET_CYCLE = 'setCycle';
export const CLEAR_CYCLE = 'clearCycle';
export const CLEAR_EQT_STATE = 'clearEqtState';
